import { create } from 'zustand';

import {
  getEmptyTransformRuleGroup,
  getInitialActiveIndices,
} from '@components/data-transform-panel/utils/initializeUtils';
import { ERenameTitle, ERenamedDimension } from '@src/common/constant/enum';
import { ITransformRule } from '@src/common/types/empTypes';

export interface ITransformItemActiveIndices {
  subAndIndex?: number;
  subOrIndex?: number;
}

export interface ITransformActiveIndices {
  orIndex?: number;
  metadataNameActive?: boolean;
  ruleItems?: ITransformItemActiveIndices[];
}

export interface IDataTransformPanelStore {
  transformPanelOpen: boolean;
  transformActiveIndices?: ITransformActiveIndices;
  transformTitle?: string;
  transformId?: number;
  transformName?: string;
  transformTargetDimension?: string;
  transformRule: ITransformRule[];
  setTransformActiveIndices: (transformActiveIndices?: ITransformActiveIndices) => void;
  setTransformTitle: (transformTitle?: string) => void;
  setTransformId: (transformId?: number) => void;
  setTransformName: (transformName?: string) => void;
  setTransformTargetDimension: (transformTargetDimension?: string) => void;
  setTransformRule: (transformRule: ITransformRule[]) => void;
  setTransformPanelOpen: (transformPanelOpen: boolean) => void;
  resetTransformStore: () => void;
}

export const useDataTransformPanelStore = create<IDataTransformPanelStore>((set) => ({
  transformPanelOpen: false,
  transformActiveIndices: getInitialActiveIndices(),
  transformTitle: ERenameTitle.PAGE,
  transformId: undefined,
  transformName: undefined,
  transformTargetDimension: ERenamedDimension.edited_page_title,
  transformRule: [getEmptyTransformRuleGroup()],
  setTransformActiveIndices: (transformActiveIndices) => set(() => ({ transformActiveIndices })),
  setTransformId: (transformId) => set(() => ({ transformId })),
  setTransformTitle: (transformTitle) => set(() => ({ transformTitle })),
  setTransformName: (transformName) => set(() => ({ transformName })),
  setTransformTargetDimension: (transformTargetDimension) =>
    set(() => ({ transformTargetDimension })),
  setTransformRule: (transformRule) => set(() => ({ transformRule })),
  setTransformPanelOpen: (transformPanelOpen) => set(() => ({ transformPanelOpen })),
  resetTransformStore: () =>
    set(() => ({
      transformPanelOpen: false,
      transformActiveIndices: getInitialActiveIndices(),
      transformTitle: ERenameTitle.PAGE,
      transformId: undefined,
      transformName: undefined,
      transformTargetDimension: ERenamedDimension.edited_page_title,
      transformRule: [getEmptyTransformRuleGroup()],
    })),
}));
